<template>
<div class="chapter">
<div class="inner_page">
<p class="C72_4"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="C83"><a id="page_v"><em></em></a><em><a href="#/xhtml/04_A_Note_o#page_vii">A Note on Sources</a></em></p>
<p class="C72"><a href="#/xhtml/05_An_Image#page_1">An Image of God, Not a Mere Animal: An Introduction</a></p>
<p class="C85_5"><a href="#/xhtml/06_One___Fo#page_13">ONE. For the Welfare of the Race: The Early Clash over Reproduction and Community</a></p>
<p class="C85_5"><span href="#/xhtml/07_Two___Co#page_36" title="Link target outside of Sample">TWO. Cooperative Clergy? Catholics in the American Eugenics Society</span></p>
<p class="C85_5"><span href="#/xhtml/08_Three__#page_66" title="Link target outside of Sample">THREE. Practical Means: Catholic Strategies for Protesting Sterilization Statutes</span></p>
<p class="C85_5"><span href="#/xhtml/09_Four___S#page_89" title="Link target outside of Sample">FOUR. Supreme Authorities: Catholicism and Eugenics beyond the Borders</span></p>
<p class="C85_5"><span href="#/xhtml/10_Five___T#page_114" title="Link target outside of Sample">FIVE. The Greatest Obstacle: The Growth of a Confident Opposition</span></p>
<p class="C85_5"><span href="#/xhtml/11_Six___A#page_140" title="Link target outside of Sample">SIX. A Great, Popular, Noncontroversial, and Effective Movement: Struggling with the “New Eugenics”</span></p>
<p class="C72"><em><span href="#/xhtml/12_Epilogue#page_163" title="Link target outside of Sample">Epilogue</span></em></p>
<p class="C86"><em><span href="#/xhtml/13_Acknowle#page_171" title="Link target outside of Sample">Acknowledgments</span></em></p>
<p class="C86"><em><span href="#/xhtml/14_Notes#page_175" title="Link target outside of Sample">Notes</span></em></p>
<p class="C86"><em><span href="#/xhtml/15_Bibliogr#page_201" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C86"><em><span href="#/xhtml/16_Index#page_219" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?59675200